import React, { forwardRef } from "react";
import Grid from "@material-ui/core/Grid";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import CancelPresentationIcon from "@material-ui/icons/CancelPresentation";
import { Paper, Fade, Box, Divider, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Chip, Button } from "@material-ui/core";
import Stack from "@mui/material/Stack";
import TeamBreakdownModal from "../TeamBreakdownModal";
import Autocomplete from "_components/core/Autocomplete_";

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.GrayPrg.main,
    color: theme.palette.DarkGrayPrg.main,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const useStyles = makeStyles((theme) => ({
  paper: {
    position: "relative",
    backgroundColor: theme.palette.WhitePrg.main,
    boxShadow: theme.shadows[5],
    padding: "20px",
    borderRadius: "4px",
    width: "90vw",
    minHeight: "90vh",
    height: "fit-content",
    overflow: "hidden",
  },
  close: {
    cursor: "pointer",
  },
  save: {
    backgroundColor: theme.palette.GreenPrg.main,
    color: theme.palette.WhitePrg.main,
  },
  divider: {
    margin: theme.spacing(2, 0, 0, 0),
    backgroundColor: theme.palette.WhitePrg.main,
  },
  h3: {
    color: "var(--LightGray)",
    margin: "0 0 10px 0",
  },
  goals: {
    textAlign: "center",
    fontWeight: "bolder",
    marginTop: "10px",
    padding: "10px",
  },
  goalsInner: {
    backgroundColor: theme.palette.WhitePrg.main,
    border: `solid 4px ${theme.palette.GrayPrg.main}`,
  },
  status: {
    backgroundColor: theme.palette.GreenPrg.main,
    color: theme.palette.WhitePrg.main,
    width: "100%",
    maxWidth: "400px",
    margin: "auto",
  },
  color: {
    backgroundColor: theme.palette.GrayPrg.main,
    padding: 5,
    maxHeight: 500,
    overflow: "auto",
  },
  countColor: {
    backgroundColor: theme.palette.OverlayPrg.main,
    color: theme.palette.DarkGrayPrg.main,
    padding: "5px 0",
    fontWeight: "bolder",
  },
  padding: {
    padding: 0,
    maxHeight: "calc(90vh - 345px)",
    overflow: "auto",
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
  },
  verticalAlign: {
    verticalAlign: "top",
  },
  details: {
    display: "block",
    padding: "12px 24px 12px 16px",
    transition: ".25s ease",
    cursor: "pointer",
    border: `1px solid ${theme.palette.WhitePrg.main}`,
    "&:hover": {
      border: `1px solid ${theme.palette.GreenPrg.main}`,
    },
    flex: "1 1 calc(100%)",
    minWidth: "115px",
    minHeight: "fit-content",

  },
  completed: {
    backgroundColor: `${theme.palette.GreenPrg.main} !important`,
    color: `${theme.palette.WhitePrg.main} !important`,
  },
  startClaimDark: {
    backgroundColor: `${theme.palette.DarkGrayPrg.main} !important`,
  },
  dropdown: {
    width: "100%",
  },
}));


const DirectorB1 = forwardRef(({
    setOpenModal,
    currentDate,
    openModal,
    weekOptions,
    weekOptionsSchema,
    isRestricted,
    filteredRegions,
    statsSorted,
    teamBreakdown,
    setTeamBreakdown,
    clearTeamBreakdown,
    selectedTheme,
    handleClose,
    sortedRegions,
    toggleRegion,
    selectedRegions,
    control,
    selectedView,
    setSelectedView,
}, ref) => {
  const classes = useStyles();



  return (
    <Fade in={openModal} >
        <Paper className={classes.paper} elevation={4} ref={ref} tabIndex={-1} style={{ display: selectedView === "director" ? "block" : "none" }}>
          <Grid container>
            <Grid item xs={12} md={6}>
              <Autocomplete
                control={control}
                options={weekOptions}
                optionSchema={weekOptionsSchema}
                name={"startDate"}
                className={classes.dropdown}
                defaultValue={currentDate.clone().startOf("week").format("MM/DD/YYYY")}
              ></Autocomplete>
            </Grid>
            <Button
                variant="contained"
                color="primary"
                className={classes.save}
                onClick={() => setSelectedView("standard")}
                style={{ marginLeft: "1rem"}}
            >
              Toggle View
            </Button>
          </Grid>

          <Box style={{ position: "absolute", top: "10px", right: "10px" }}>
            <CancelPresentationIcon fontSize="large" className={classes.close} onClick={handleClose} />
          </Box>

          {/* Header */}
          <Grid container spacing={3} className={classes.goals}>
            {!isRestricted && (
              <Grid
                item
                xs={4}
                className={`${classes.goalsInner} ${selectedTheme === "dark" ? classes.startClaimDark : ""}`}
              >
                <Typography variant="body1" component="h2">
                  <Box fontWeight="fontWeightBold" m={1}>
                    Team Total:
                    <div className="teamBlocks" style={{ textDecoration: "underline" }}>
                      {filteredRegions && filteredRegions.reduce((acc, curr) => acc + curr.total, 0)}
                    </div>
                  </Box>
                </Typography>
              </Grid>
            )}
            <Grid
              item
              xs={isRestricted ? 12 : 4}
              className={`${classes.goalsInner} ${selectedTheme === "dark" ? classes.startClaimDark : ""}`}
            >
              <Typography variant="h6" component="h6" className="title">
                <Box fontWeight="fontWeightBold">B1 SCOREBOARD</Box>
              </Typography>
              <Typography variant="subtitle2" component="h2" className="subtitle">
                This Week Currently in A-Status:
              </Typography>
              <Typography variant="body1" component="h2" className={classes.status}>
                {filteredRegions && filteredRegions.reduce((acc, curr) => acc + curr.aTotal, 0)}
              </Typography>
            </Grid>
            {!isRestricted && (
              <Grid
                item
                xs={4}
                className={`${classes.goalsInner} ${selectedTheme === "dark" ? classes.startClaimDark : ""}`}
              >
                <Typography variant="body1" component="h2">
                  <Box fontWeight="fontWeightBold" m={1}>
                    Team Goal:
                    <div className="teamBlocks" style={{ textDecoration: "underline" }}>
                      {filteredRegions && filteredRegions.reduce((acc, curr) => acc + curr.RegionTargets, 0)}
                    </div>
                  </Box>
                </Typography>
              </Grid>
            )}
          </Grid>
          {/* Header */}
          <Divider className={classes.divider} />

          <div style={{ marginBottom: "0.5rem", marginTop: "0.5rem" }}>
            {sortedRegions?.length > 1 && sortedRegions.map((column) => 
              <Chip 
                label={column.RegionName}
                key={column.regionid}
                onClick={() => toggleRegion(column.regionid)}
                color={selectedRegions.includes(column.regionid) ? "primary" : "default"}
                style={{ marginRight: "0.25rem"}}
              />
            )}
          </div>
          <TableContainer className={classes.container}>
            {!filteredRegions ? (
              <Typography variant="h6" style={{ textAlign: "center" }}>
                ...Loading
              </Typography>
            ) : (
              ""
            )}
            <Table stickyHeader aria-label="sticky table" size="small">
              <TableHead>
                <TableRow>
                  {filteredRegions &&
                    filteredRegions.map((column) => {
                      let {
                        // RegionName,
                        RegionTargets,
                        aTotal,
                        regionid,
                        total,
                      } = column;
                      return (
                        <StyledTableCell
                          key={column.regionid}
                          style={{ width: "20%"}}
                          // align={column.align}
                          // style={{ minWidth: column.minWidth }}
                        >
                          <Stack>
                            <Typography variant="button">{column.RegionName}</Typography>
                            <Typography variant="button">
                              {total} /{" "}
                              {RegionTargets} (
                              {aTotal})
                            </Typography>
                          </Stack>
                        </StyledTableCell>
                      );
                    })}
                </TableRow>
              </TableHead>
              <TableBody>
                <StyledTableRow hover role="checkbox" tabIndex={-1}>
                  {filteredRegions &&
                    filteredRegions.map((col) => {
                      let {
                        // RegionName,
                        RegionTargets,
                        aTotal,
                        regionid,
                        total,
                      } = col;

                      const currentStats = [];

                      const aggregated = {};
                      statsSorted.filter((e) => e["RegionID"] === regionid).forEach((m) => {
                        aggregated[m.entityId] = {
                            RegionID: m.RegionID,
                            MarketTargets: (aggregated[m.entityId]?.MarketTargets ?? 0) + m.MarketTargets,
                            total: (aggregated[m.entityId]?.total ?? 0) + m.total,
                            aTotal: (aggregated[m.entityId]?.aTotal ?? 0) + m.aTotal,
                            entityId: m.entityId,
                            entityName: m.entityName,
                        };
                      });

                    Object.values(aggregated).forEach((e) =>
                        currentStats.push(e)
                    );

                      return (
                        <TableCell key={`${col.regionid}-${col.RegionName}`} className={classes.verticalAlign}>
                          {/* {total} / {RegionTargets} ({aTotal}) */}
                          <div className={`${classes.padding}`}>
                            {currentStats &&
                              currentStats.map((curr) => {
                                return (
                                  <span
                                    key={`${curr["RegionID"]}-${curr["entityId"]}`}
                                    onClick={() => {
                                      setTeamBreakdown({
                                        regionId: curr.RegionID,
                                        marketId: null,
                                        entityId: curr.entityId,
                                      });
                                    }}
                                    className={`${curr["total"] >= curr["MarketTargets"] ? classes.completed : ""} ${
                                      classes.details
                                    } flip`}
                                  >
                                    {curr.entityName} - {curr.total}/{curr.MarketTargets} ({curr.aTotal})
                                  </span>
                                );
                              })}
                          </div>
                        </TableCell>
                      );
                    })}
                </StyledTableRow>
              </TableBody>
            </Table>
          </TableContainer>
          {/* <TeamBreakdownModal teamBreakdown={teamBreakdown} clear={clearTeamBreakdown} setOpenModal={setOpenModal} /> */}
        </Paper>
      </Fade>
    )
});

export default DirectorB1;